import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import FieldLabel from 'src/components/FieldLabel/FieldLabel'
import { css } from 'styled-components'

interface NotesInputFieldProps {
  fieldLabel?: React.ReactNode | string
  showUpdates?: boolean
  baseValue?: string
  value?: string
  onChange: (value: string) => void
  placeholder: string
  type?: string
  disabled?: boolean
  className?: string
  autoComplete?: string
  name?: string
  // TODO: see if this lives somewhere
  inputMode?:
    | 'none'
    | 'text'
    | 'tel'
    | 'url'
    | 'email'
    | 'numeric'
    | 'decimal'
    | 'search'
  id?: string
  maxLength?: number
  notesCharacters?: number
  showSaving?: boolean
  setShowSaving?: (val: boolean) => void
}

const NotesInputField: React.FC<NotesInputFieldProps> = (
  props,
): React.ReactElement => {
  const onChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ): void => {
    props.onChange(e.target.value)
    if (!props.showSaving) {
      props.setShowSaving && props.setShowSaving(true)
    }
  }

  return (
    <div
      id={props.id}
      className={props.className}
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      {props.fieldLabel !== undefined && (
        <>
          <FieldLabel>{props.fieldLabel}</FieldLabel>
        </>
      )}
      <div
        css={css`
          position: relative;
        `}
      >
        <textarea
          data-testid={'notesInput'}
          placeholder={props.placeholder}
          value={props.value}
          onChange={onChange}
          disabled={props.disabled}
          autoComplete={props.autoComplete || 'off'}
          name={props.name}
          inputMode={props.inputMode}
          maxLength={
            props.maxLength !== undefined ? props.maxLength : undefined
          }
          css={css`
            width: 100%;
            border-radius: 6px;
            min-height: 100px;
            max-height: 100px;
            resize: none;
            border: 1px solid ${styleConstants.colors.gray_medium};
            padding: 20px;
            caret-color: ${themeConstants.colors.cta};
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};

            background-color: ${styleConstants.colors.gray_lightest};
            &::placeholder {
              opacity: 0.5;
              ${getFontCss(
                14,
                styleConstants.colors.gray_darkest,
                styleConstants.fontFamilies.regular,
              )};
            }

            &:focus,
            &:hover {
              background-color: ${styleConstants.colors.white};
              border: 1px solid ${themeConstants.colors.cta};
              outline: none;
            }
          `}
        />
        {props.maxLength !== undefined && (
          <div
            css={css`
              margin-top: 5px;
              position: absolute;
              top: 76px;
              right: 10px;
              ${getFontCss(
                12,
                styleConstants.colors.gray_dark,
                styleConstants.fontFamilies.regular,
              )};
            `}
          >
            {`${props.notesCharacters || 0}/${props.maxLength}`}
          </div>
        )}
      </div>
    </div>
  )
}

export default React.memo(NotesInputField)
